// context/SoftphoneContext.tsx
import React, { createContext, useContext, ReactNode } from 'react';
import useSoftphone from '../hooks/features/calls/useSoftphone';

const SoftphoneContext = createContext<ReturnType<typeof useSoftphone> | null>(null);

export function SoftphoneProvider({ children }: { children: ReactNode }) {
  const softphone = useSoftphone();
  
  return (
    <SoftphoneContext.Provider value={softphone}>
      {children}
    </SoftphoneContext.Provider>
  );
}

export function useSoftphoneContext() {
  const context = useContext(SoftphoneContext);
  if (!context) {
    throw new Error('useSoftphoneContext must be used within SoftphoneProvider');
  }
  return context;
}